export default __webpack_public_path__ + "static/media/04-min.bf3f6a22.jpg";